import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchTenants } from "../lib/api-client";
import { ApiError } from "../lib/api-client";
import { ErrorAlert } from "../components/Alert";
import type { Tenant } from "../lib/types";

export function TenantsPage() {
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTenants()
      .then(setTenants)
      .catch((err) => setError(err instanceof ApiError ? err.message : "テナント一覧の取得に失敗しました"))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div>
      <h1 className="text-xl font-semibold mb-4">テナント一覧</h1>
      <ErrorAlert message={error} />
      {isLoading ? (
        <p className="text-sm text-gray-500">読み込み中...</p>
      ) : tenants.length === 0 ? (
        <p className="text-sm text-gray-500">所属テナントがありません</p>
      ) : (
        <ul className="divide-y divide-gray-200 bg-white border border-gray-200 rounded-lg">
          {tenants.map((tenant) => (
            <li key={tenant.id} className="px-4 py-3 hover:bg-gray-50">
              <Link to={`/tenants/${tenant.id}/sites`} className="text-blue-600 hover:underline">
                {tenant.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
